import { PhoneBookEntries } from 'src/models/phoneCall';

import { Callback } from 'src/util/query/models/Callback';

import { SetThePhoneBookEntriesPayload } from '../interfaces';

export class GetThePhoneBookQueryQueryCallback extends Callback<PhoneBookEntries> {
	public constructor(private readonly setPhoneBookEntries: (payload: SetThePhoneBookEntriesPayload) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: PhoneBookEntries): void => {
		this.setPhoneBookEntries({
			phoneBookEntries: successResponse,
		});
	};
}
